var exports = {
  "kL": "xae11d333--201571--container",
  "vW": "xae11d333--201571--inner",
  "h_": "xae11d333--201571--description",
  "h3": "xae11d333--201571--description-text",
  "VZ": "xae11d333--201571--banks-list",
  "x6": "xae11d333--201571--button",
};

module.exports = exports;
